const { Component } = wp.element;
const { PanelBody, PanelRow, Button, Text } = wp.components;
const { InnerBlocks, RichText, ColorPalette, InspectorControls, MediaUpload } = wp.blockEditor;

const [ALLOWED_MEDIA_TYPES] =   ['image','video'];

class Edit extends Component {

    render() {

        const { className, attributes, setAttributes, styles } = this.props;

        return([
            <InspectorControls>
                <PanelBody title="Info Box Settings">
	                <h3>Background Color:</h3>
                    <ColorPalette 
							className={ className }
                    		value={ attributes.textBg }
							onChange={ (newtextBg) => setAttributes({textBg: newtextBg}) }
                          />
	                <h3>Text Color:</h3>
					<ColorPalette value={ attributes.textColor }
					    onChange={ (newColor) => setAttributes({textColor: newColor}) }
					    />
                </PanelBody>
            </InspectorControls>,

            <div className={ className + " db-info-container" }>
                <div class="column_1">
                    <div class="db-media"
                    style={{ backgroundImage: Object.keys(attributes.bgImage).length === 0 ? "none" : `url(${attributes.bgImage.url})` }}
                    >
                    <MediaUpload
                        onSelect={ (newImage) => setAttributes({bgImage: newImage}) }
                        value={ attributes.bgImage }
                        allowedTypes={ ALLOWED_MEDIA_TYPES }
                        render={ ( { open } ) => {
                            return(
                                <Button
                                    onClick={ open }
                                    icon="upload"
                                    className="editor-media-placeholder__button is-button is-default is-large is-primary">
                                    Upload Image
                                </Button>
                            )
                        } }
                         />
                    </div>
                </div>
                <div className="column_2" style={ { background: attributes.textBg } }>
                    <RichText
                            tagName="h2"
                            value={ attributes.textTitle }
                            style={ { color: attributes.textColor } }
                            onChange={ (newTitle) => setAttributes({textTitle: newTitle})}
                            placeholder="Enter Title..."
                            />
                    <RichText key="editable"
                              tagName="p"
                              placeholder="Enter Text..."
                              value={ attributes.textContent }
                              style={ { color: attributes.textColor } }
                              onChange={ (newContent) => setAttributes({textContent: newContent}) }
                              />
                </div>
            </div>
        ])
    }
}

export default Edit;
